module.exports = __webpack_public_path__ + "media/images/modals/okra_and_beat_EPISODE2_v2-cc7cc16156d20ef912215964bd961341.jpg";